export const CANARA_BANK = "Canara Bank";
export const ICICI_BANK = "ICICI Bank";
export const AXIS_BANK = "Axis Bank";
export const INDIAN_BANK = "Indian Bank";
export const BOOK = "BOOK";
export const BANK = "BANK";

export const ALL_TAB_BG = "rgb(63, 121, 181)";
export const PARTIAL_TAB_BG = "rgb(255, 214, 154)";
export const MATCHED_BG = "rgb(196, 255, 198)";
export const BOOK_TAB_BG = "rgb(255, 200, 196)";
export const BANK_TAB_BG = "rgb(193, 228, 255)";
export const ALREADY_TAB_BG = "rgb(204, 204, 204)";
